import { render, staticRenderFns } from "./CuponsPrincipal.vue?vue&type=template&id=4a9b80ac&scoped=true&"
import script from "./CuponsPrincipal.vue?vue&type=script&lang=js&"
export * from "./CuponsPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9b80ac",
  null
  
)

export default component.exports